(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reserve-banner-inline"] && !Shopify.designMode) return;
  try {
    
(function() {
  var btn = document.getElementById('reserve-submit-btn');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var wrapper = document.getElementById('reserve-inline-form');
    var inputs = wrapper.getElementsByTagName('input');
    var firstName = inputs[0] ? inputs[0].value.trim() : '';
    var email = inputs[1] ? inputs[1].value.trim() : '';
    if (!firstName || !email) {
      if (!firstName) inputs[0].focus();
      else inputs[1].focus();
      return;
    }
    btn.textContent = 'JOINING...';
    btn.disabled = true;
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'THE RESERVE Inline Banner',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: firstName,
                properties: {
                  'Reserve Tier': 'Silver',
                  'Reserve Source': 'Website - Homepage Banner'
                }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: 'U88q7F' }
            }
          }
        }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Uvsk5n', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(payload)
    })
    .then(function(r) {
      if (r.ok || r.status === 202) {
        wrapper.innerHTML = '<div style="text-align:center;padding:20px;"><div style="font-family:Cormorant Garamond,serif;font-size:22px;color:#1a1a1a;margin-bottom:8px;">Welcome to The Reserve.</div><div style="font-family:Montserrat,sans-serif;font-size:10px;letter-spacing:2px;color:#555;">YOUR INVITATION HAS BEEN CONFIRMED</div></div>';
      } else {
        btn.textContent = 'ENTER THE RESERVE \u2192';
        btn.disabled = false;
      }
    })
    .catch(function() {
      btn.textContent = 'ENTER THE RESERVE \u2192';
      btn.disabled = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
